'use client'

import { SessionProvider } from "next-auth/react"
import { Session } from "next-auth";
import { useSite } from "@/client/provider/site-context-provider.tsx";

export default function Provider(
  {
    children,
    session
  }: {
    children: React.ReactNode
    session: Session | null
  }): React.ReactNode {
  const site = useSite()
  const rootDomain = site.siteName.split('.').slice(-2).join('.');

  return (
    <SessionProvider
      session={session}
      baseUrl={`https://${rootDomain}`}
      basePath="/api/auth"
      refetchInterval={0}
      refetchOnWindowFocus={false}
      refetchWhenOffline={false}
    >
      {children}
    </SessionProvider>
  );
}